import { post } from '../helpers/caller'

const domain = 'ledger'
export const ledger = {
  triggerAchPull(body: any) {
    return post(domain, ledger.triggerAchPull, body)
  },
  triggerAchOut(body: any) {
    return post(domain, ledger.triggerAchOut, body)
  },
  triggerCardPull(body: any) {
    return post(domain, ledger.triggerCardPull, body)
  },
  triggerPaymentOrderCancel(body: any) {
    return post(domain, ledger.triggerPaymentOrderCancel, body)
  },
}
